import React, { Component } from "react";
import "./AddMoney.css";
import QRCode from "qrcode.react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import coin from "./images/icon_coin_balance.png";
// Change language
import PropTypes from "prop-types";
import en from "./languages/en.json";
import th from "./languages/th.json";

// Translation Higher Order Component
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from "react-switch-lang";

// Do this two lines only when setting up the application
setTranslations({ en, th });
// setDefaultLanguage("th");

// If you want to remember selected language
setLanguageCookie();

const apiUrl =
  "https://centapi.andamandaphuket.com:8443/centaman_test.api/v3/giftcards?GiftcardNo=";

class AddMoney extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      current: 0,
    };
  }

  handleChange(event) {
    setLanguage(event.target.value);
    this.wristbandInput.focus();
  }

  componentDidMount() {
    // Start counting when the page is loaded
    this.timeoutHandle = setTimeout(() => {
      setLanguage("th");
      this.props.history.push("/");
    }, 10000);
    this.wristbandInput.focus();
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHandle);
  }

  // getUserDetail = async (wristband) => {
  //   try {
  //     const response = await fetch(apiUrl + wristband, {
  //       method: "GET",
  //       headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
  //     });
  //     const result = await response.json();
  //     const userDetail = result[0];
  //     if (result.error) {
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //     } else {
  //       //3322780051
  //       this.wristbandInput.value = "";
  //       this.setState({ wristband: "" });
  //       this.props.history.push({
  //         pathname: "/page3",
  //         state: {
  //           giftcardNo: userDetail.GiftcardNo,
  //           giftcardExpiryDate: userDetail.GiftcardExpiryDate,
  //           cashOutBalance: userDetail.CashOutBalance,
  //           restrictedBalance: userDetail.RestrictedBalance,
  //           totalBalance: userDetail.TotalBalance,
  //         },
  //       });
  //     }
  //   } catch (error) {
  //     this.wristbandInput.value = "";
  //     this.setState({ wristband: "" });
  //     this.props.history.push({
  //       pathname: "/page5",
  //       state: {

  //       },
  //     });
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  // handleWristbandKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     console.log("Enter press...", e.target.value);
  //     this.setState({ wristband: e.target.value });
  //     this.getUserDetail(e.target.value);
  //   }
  // };

  getUserDetail = (wristband) => {
    return new Promise((resolve, reject) => {
      fetch(apiUrl + parseInt(wristband), {
        method: "GET",
        headers: { Authorization: "Basic " + btoa("ANDAMAPI:200acabovul") },
      })
        .then((response) => response.json())
        .then((result) => {
          const userDetail = result[0];

          if (userDetail) {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });

            const stateData = {
              giftcardNo: userDetail.GiftcardNo,
              giftcardExpiryDate: userDetail.GiftcardExpiryDate,
              cashOutBalance: userDetail.CashOutBalance,
              restrictedBalance: userDetail.RestrictedBalance,
              totalBalance: userDetail.TotalBalance,
            };

            this.props.history.push({
              pathname: "/page3",
              state: stateData,
            });

            resolve(stateData);
          } else {
            this.wristbandInput.value = "";
            this.setState({ wristband: "" });
            resolve(null); // Resolve with null to indicate no user detail
          }
        })
        .catch((error) => {
          this.wristbandInput.value = "";
          this.setState({ wristband: "" });

          this.props.history.push({
            pathname: "/page5",
            state: {
              wristband: wristband,
            },
          });

          reject(error); // Reject with the error
        })
        .finally(() => {
          // setLoading(false);
        });
    });
  };

  handleWristbandKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState({ wristband: e.target.value });
      this.getUserDetail(e.target.value)
        .then((stateData) => {
          if (stateData === null) {
            // Handle case where no user detail was found
            console.log("No user detail found");
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  render() {
    const { t } = this.props;
    const wristband = `ANDKIOSK-${this.props?.location?.state?.wristband}`;

    return (
      <div className="main" onClick={() => this.wristbandInput.focus()}>
        <input
          style={{
            opacity: "0",
            width: 0,
            height: 0,
          }}
          autoFocus={true}
          onKeyDown={this.handleWristbandKeyDown}
          ref={(inputEl) => (this.wristbandInput = inputEl)}
        />
        <div>
          <div className="leftSection">
            <div className="txtAvailableBalance">{t("pleaseAddMoney")}</div>
            <div className="txtAvailableBalance">{t("toWristBand")}</div>
          </div>
          <div className="rightSectionBg"></div>
          <div className="rightSection">
            <div className="txtConnect">
              {t("easyToConnet")} <br />
              {t("byAndamanda")}
            </div>
            <div className="qrCodeContainer">
              <QRCode
                value={wristband ?? "Not found"}
                size="222"
                renderAs="svg"
                level={"H"}
                fgColor="#333"
                bgColor="#fff"
                key={`level-H`}
                style={{
                  marginTop: "13px",
                  marginBottom: "13px",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              />
              <div className="seeInstructionContainer">
                {/* <Link
                  to={{
                    pathname: "/page4",
                    param: {
                      giftcardNo: wristband,
                    },
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#F4327B",
                    fontSize: "36px",
                  }}
                >
                  {t("seeInstruction")}
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AddMoney.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(AddMoney);
